import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { useSelector } from 'react-redux';
import usePortfolioBalance from '../../hooks/usePortfolioBalance';

const displayFont = '"Cormorant Garamond", Georgia, "Times New Roman", serif';

const BalanceCard = () => {
  const user = useSelector((state) => state.user.user);
  const { totalWalletUsd, formatUsd } = usePortfolioBalance();
  const [isVisible, setIsVisible] = useState(true);
  const displayName = user?.name || 'Member';
  const accountCode = user?.referral_code || '';

  return (
    <Box sx={{ px: 2, pt: 2, textAlign: 'center', color: 'text.primary' }}>
      <Typography sx={{ color: 'text.secondary', fontFamily: displayFont, fontStyle: 'italic', fontWeight: 500, fontSize: 20 }}>
        Welcome back,
      </Typography>
      <Typography sx={{ fontFamily: displayFont, fontWeight: 600, fontSize: { xs: 34, sm: 42 }, lineHeight: 1.05, mt: 0.5 }}>
        {displayName}
      </Typography>
      {accountCode ? (
        <Typography sx={{ color: 'text.secondary', letterSpacing: '0.22em', fontSize: 12, fontWeight: 500, mt: 1 }}>
          {accountCode}
        </Typography>
      ) : null}

      <Typography sx={{ fontFamily: displayFont, fontWeight: 600, fontSize: { xs: 48, sm: 56 }, lineHeight: 1, mt: 1.5 }}>
        {isVisible ? formatUsd(totalWalletUsd) : '••••••'}
      </Typography>
      <Typography sx={{ color: 'text.secondary', fontSize: 16, mt: 0.5 }}>
        {isVisible ? formatUsd(totalWalletUsd) : '••••••'}
      </Typography>
      <IconButton
        onClick={() => setIsVisible((current) => !current)}
        aria-label={isVisible ? 'Hide balance' : 'Show balance'}
        sx={{ color: 'text.secondary', mt: 0.5 }}
      >
        {isVisible ? <VisibilityIcon /> : <VisibilityOffIcon />}
      </IconButton>
    </Box>
  );
};

export default BalanceCard;
